import { MonaTerminal, Rectangle } from '@mona/terminal-api';

export class MonaTerminalEmulator implements Partial<MonaTerminal> {
    getVersions() {
        return Promise.resolve({
            browser: 'Test Browser',
            chrome: 'Test Chrome',
            electron: 'Test Electron',
            tools: 'Test Tools',
            eos: 'Test EOS',
            terminal: 'Test Terminal',
        });
    }

    getID() {
        const id = localStorage.getItem('id') || '11-11-11-11-11-11';
        return Promise.resolve(id);
    }

    rfid = {
        onScan(callback) {
            this.scanCallback = callback;
        },
    };

    crypto = {
        getJWT(name: 'core' | 'telemedicine') {
            // NOTE: This is static JWT token to emulate RFID usage
            // For sake of simplicity and not importing useless libraries to FE repo this token is hardcoded
            // Without emulation, those responsibilities are on MonaTerminal API
            // More about RFID emulation here: https://clinomic.atlassian.net/wiki/spaces/MD/pages/860160033/RFID+Emulation
            return Promise.resolve(
                `eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3NDAwODY0MTMsImV4cCI6MjA1NTQ0NjQxMywic3ViIjoiMTEtMTEtMTEtMTEtMTEtMTEifQ.ilJFebkCTkgvbvl4lQb9sDFOoWP253RgRLgANDvlArdHUPjMMj3eTQs6auq936OGEvxmZqpOTeqQ27_VLQPgO4bMpqfkcOBd7b5r8pPZtAsmYrVh3a3spzLQJf-yrjiP3Gupe-pzMRpGyUKpD4L63gjeghYu-f3DtGi1xWftYIgknHexPUBZ5Ly1JbCMsWmRoZuAFQiV5lEcRTSt_ist46rN5oX49Msnq_dVU-Qwtpsq3ZozelJgtHT0PXS0LwDpA3yAB2XwNJltzkkpWsjI5SflZRmcYNyl2pVVV1qZWfFTvuia52PulIX2-pqFSAmBPr6FK4YokfA_ymYCfjsHFw`,
            );
        },

        getPublicKey(name: 'core' | 'telemedicine') {
            return Promise.resolve('mock-key');
        },
    };

    camera = {
        enable(): Promise<string> {
            return Promise.resolve('enabled');
        },

        disable(): Promise<string> {
            return Promise.resolve('disabled');
        },
    };

    display = {
        getBrightness() {
            return Promise.resolve(100);
        },

        setBrightness(value: number) {
            return Promise.resolve(String(100));
        },
    };

    led = {
        off() {
            return Promise.resolve('off');
        },

        playSuccess() {
            return Promise.resolve('playSuccess');
        },

        playScan() {
            return Promise.resolve('playScan');
        },

        playWarning() {
            return Promise.resolve('playWarning');
        },
    } as any;

    settings = {
        open() {
            return Promise.resolve('Mona Terminal Settings');
        },

        getLegacyConfig() {
            return JSON.parse(localStorage.getItem('mona-config.json')) || {};
        },

        setTimeZone(timezone) {
            return Promise.resolve(timezone);
        },

        getTimeZone() {
            return Promise.resolve('America/Campo_Grande');
        },

        reboot() {
            return Promise.resolve('Reboot of Mona');
        },

        shutdown() {
            return Promise.resolve('Shutdown of Mona');
        },
    };

    chrome = {
        getMediaSourceId() {
            return Promise.resolve('mock-id');
        },
    };

    view = {
        create(bounds: Rectangle, url: string) {
            return Promise.resolve('create');
        },

        remove() {
            return Promise.resolve('remove');
        },

        setBounds(bounds: Rectangle) {
            return Promise.resolve('setBounds');
        },

        loadURL(url: string) {
            return Promise.resolve('loadURL');
        },

        goBack() {
            return Promise.resolve('goBack');
        },

        goForward() {
            return Promise.resolve('goForward');
        },

        reload() {
            return Promise.resolve('reload');
        },
    };

    osk = {
        setTheme(theme: 'light' | 'dark') {
            return Promise.resolve('light');
        },

        show() {
            return Promise.resolve('Show OSK');
        },

        hide() {
            return Promise.resolve('Hide OSK');
        },

        setAutoShow(enable: boolean) {
            return Promise.resolve('Auto show OSK enabled');
        },

        setLanguage(code: string) {
            return Promise.resolve('en-GB');
        },

        onViewChange(callback: (visible: boolean, bounds: Rectangle) => void) {
            return;
        },
    };
}
